import { Grid, Typography } from '@mui/material';

export const EmptyTrashLabel = () => {
  return (
    <Grid
      sx={{
        width: '100%',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontSize: '14px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        No trash items available.
      </Typography>
    </Grid>
  );
};
